import { renderStreamMessage } from '@hotwired/turbo'

// "Remind until signed" in the send dialog. Flipping it saves the account's reminders on/off default right away
// (the same switch as Settings > Notifications) and the server answers with a toast saying it applies to
// future sends too.
export default class extends HTMLElement {
  connectedCallback () {
    this.checkbox = this.querySelector('input[type="checkbox"]')
    this.checkbox?.addEventListener('change', this.save)
  }

  disconnectedCallback () {
    this.checkbox?.removeEventListener('change', this.save)
  }

  save = async () => {
    const enabled = this.checkbox.checked

    this.showState(enabled)

    try {
      const response = await fetch(this.dataset.url, {
        method: 'PATCH',
        headers: {
          Accept: 'text/vnd.turbo-stream.html',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ enabled: enabled ? '1' : '0' })
      })

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      renderStreamMessage(await response.text())
    } catch {
      this.checkbox.checked = !enabled
      this.showState(!enabled)
    }
  }

  showState (enabled) {
    this.querySelector('[data-reminders-on]').classList.toggle('hidden', !enabled)
    this.querySelector('[data-reminders-off]').classList.toggle('hidden', enabled)
  }
}
